import { WebStorageStateStore, UserManager } from 'oidc-client-ts';
import { oidcSettings } from '../config/oidc';

const camelCaseToSnakeCase = string => {
  return string
    .split(/(?=[A-Z])/)
    .join('_')
    .toLowerCase();
};

const settingsThatAreSnakeCasedInOidcClient = [
  'clientId',
  'redirectUri',
  'responseType',
  'maxAge',
  'uiLocales',
  'loginHint',
  'acrValues',
  'postLogoutRedirectUri',
  'popupRedirectUri',
  'silentRedirectUri'
];

const snakeCasedSettings = oidcSettings => {
  settingsThatAreSnakeCasedInOidcClient.forEach(setting => {
    if (typeof oidcSettings[setting] !== 'undefined') {
      oidcSettings[camelCaseToSnakeCase(setting)] = oidcSettings[setting];
    }
  });
  return oidcSettings;
};

const objectAssign = objects => {
  return objects.reduce(function(r, o) {
    Object.keys(o || {}).forEach(function(k) {
      r[k] = o[k];
    });
    return r;
  }, {});
};

const requiredConfigProperties = [
  'authority',
  'client_id',
  'redirect_uri',
  'response_type',
  'scope'
];

const defaultOidcConfig = {
  userStore: new WebStorageStateStore(),
  loadUserInfo: true,
  automaticSilentSignin: true
};

const getOidcConfig = oidcSettings => {
  return objectAssign([
    defaultOidcConfig,
    snakeCasedSettings(oidcSettings),
    { automaticSilentRenew: false }
  ]);
};

export const createOidcUserManager = oidcSettings => {
  const oidcConfig = getOidcConfig(oidcSettings);
  requiredConfigProperties.forEach(requiredProperty => {
    if (!oidcConfig[requiredProperty]) {
      throw new Error(
        'Required oidc setting ' +
          requiredProperty +
          ' missing for creating UserManager'
      );
    }
  });
  return new UserManager(oidcConfig);
};

export const errorPayload = (context, error) => {
  return {
    context,
    error: error && error.message ? error.message : error
  };
};

export const tokenExp = token => {
  if (token) {
    const parsed = parseJwt(token);
    return parsed.exp ? parsed.exp * 1000 : null;
  }
  return null;
};

export const tokenIat = token => {
  if (token) {
    const parsed = parseJwt(token);
    return parsed.iat ? parsed.iat * 1000 : null;
  }
  return null;
};

export const parseJwt = token => {
  try {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace('-', '+').replace('_', '/');
    return JSON.parse(window.atob(base64));
  } catch (error) {
    return {};
  }
};

export const tokenIsExpired = token => {
  const tokenExpiryTime = tokenExp(token);
  if (tokenExpiryTime) {
    return tokenExpiryTime < new Date().getTime();
  }
  return false;
};

export const vuexOidcProcessSilentSignInCallback = () => {
  return createOidcUserManager(oidcSettings).signinSilentCallback();
};
